import React from 'react';


const ButtonSecondary = ({name, onClick, disabled, className, onSelectStatus,row,options, props}) => {

  return (
    <button
      className={`btn btn--secondary ${className ? className : ''}`}
      onClick={onClick}
      disabled={disabled}
      type='button'
      {...props}
    >
      <span>{name}</span>
    </button>
  );
}

export default ButtonSecondary;
